module.exports = __webpack_public_path__ + "img/CDISCOUNT.1d08417a.png";